// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.63-TSS-3049-mcastro-IMPROVEMENT-Group-Header-Widths.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
